//@flow
import React from "react";

type Props = {
  size: number,
  color: string
};

export default function Expanse({ size, color = "currentColor" }: Props) {
  return (
    <svg viewBox="0 0 16 16" width={size} height={size}>
      <path
        fill={color}
        d="M7.847 0l7.297 3.47v9.239L7.854 16 .7 12.704V3.51L7.847 0zm.85 11.515c1.617-.402 2.817-1.849 2.817-3.576 0-.525-.11-1.024-.31-1.476L13.52 5.3v6.362L8.695 13.84v-2.324zm-1.624.045v2.293l-4.75-2.188v-6.33l2.072 1.057c-.22.47-.343.994-.343 1.547 0 1.799 1.302 3.293 3.021 3.62zM5.415 5.09L3.329 4.026l4.53-2.223 4.626 2.2-2.269 1.14a3.743 3.743 0 0 0-2.433-.892 3.74 3.74 0 0 0-2.368.839zm2.368.784c1.167 0 2.108.927 2.108 2.065 0 1.137-.941 2.064-2.108 2.064-1.167 0-2.108-.927-2.108-2.064 0-1.138.941-2.065 2.108-2.065z"
      />
    </svg>
  );
}
